import { FeatureNames } from '@/lib/featureFlags'
import { useFeatureFlags } from '@/hooks/use-feature-flags'

type Props = {
  flag: FeatureNames
  enabled: React.ComponentType<any>
  disabled: React.ComponentType<any>
  componentProps?: any
}

export const FeatureFlagRoute = ({
  flag,
  enabled: Enabled,
  disabled: Disabled,
  componentProps,
}: Props) => {
  const { isFeatureEnabled, isLoaded } = useFeatureFlags()

  // Les flags arrivent de la gateway : la branche « désactivée » redirige, pas avant leur lecture.
  if (!isLoaded) return null

  const Component = isFeatureEnabled(flag) ? Enabled : Disabled

  return <Component {...componentProps} />
}
